/* Secundo custom navigation — behavior (progressive enhancement) */
(function () {
  var prefetched = {};
  function prefetch(url) {
    if (!url || prefetched[url] || url.charAt(0) !== '/') return;
    prefetched[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.href = url;
    document.head.appendChild(l);
  }

  /* ---------- DESKTOP ---------- */
  class SecundoNav extends HTMLElement {
    connectedCallback() {
      this.openDelay = parseInt(this.dataset.openDelay || '100', 10);
      this.closeDelay = parseInt(this.dataset.closeDelay || '200', 10);
      this.openTimer = null; this.closeTimer = null; this.active = null;
      this.items = Array.from(this.querySelectorAll('.snav__top-item'));

      this.items.forEach((item) => {
        var trigger = item.querySelector('.snav__top-link');
        var panel = item.querySelector('.snav__panel');
        if (!trigger || !panel) return;

        item.addEventListener('pointerenter', () => {
          if (window.matchMedia('(hover:none)').matches) return;
          clearTimeout(this.closeTimer);
          this.openTimer = setTimeout(() => this.open(item), this.active ? 0 : this.openDelay);
        });
        item.addEventListener('pointerleave', () => {
          clearTimeout(this.openTimer);
          this.scheduleClose();
        });
        // Keyboard / non-hover: toggle on activate. Buttons (no href) toggle; links toggle only via keyboard.
        trigger.addEventListener('click', (e) => {
          var isButton = trigger.tagName === 'BUTTON';
          var noHover = window.matchMedia('(hover:none)').matches;
          if (isButton || noHover) { e.preventDefault(); item === this.active ? this.close() : this.open(item); }
        });
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { this.close(); trigger.focus(); }
        });
        // Prefetch destinations on hover
        panel.querySelectorAll('a[href]').forEach((a) => {
          a.addEventListener('pointerenter', () => prefetch(a.getAttribute('href')));
        });
        var th = trigger.getAttribute('href');
        if (th) trigger.addEventListener('pointerenter', () => prefetch(th));
      });

      this._onDocKeydown = (e) => { if (e.key === 'Escape') this.close(); };
      this._onDocClick = (e) => { if (this.active && !this.contains(e.target)) this.close(); };
      document.addEventListener('keydown', this._onDocKeydown);
      document.addEventListener('click', this._onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this._onDocKeydown);
      document.removeEventListener('click', this._onDocClick);
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
    }
    open(item) {
      if (this.active === item) return;
      if (this.active) this._hide(this.active);
      this.active = item;
      var trigger = item.querySelector('.snav__top-link');
      var panel = item.querySelector('.snav__panel');
      panel.hidden = false;
      // Cap the panel's inner scroll region to the viewport: measure its distance from the
      // top now (accounts for the announcement bar and the sticky/reduced header state) so a
      // panel taller than the screen scrolls instead of spilling below the fold. See the
      // --snav-panel-top calc() in secundo-nav.css.
      var panelTop = Math.max(0, Math.round(panel.getBoundingClientRect().top));
      panel.style.setProperty('--snav-panel-top', panelTop + 'px');
      requestAnimationFrame(() => panel.classList.add('is-open'));
      trigger.setAttribute('aria-expanded', 'true');
    }
    scheduleClose() { clearTimeout(this.closeTimer); this.closeTimer = setTimeout(() => this.close(), this.closeDelay); }
    close() { if (this.active) { this._hide(this.active); this.active = null; } }
    _hide(item) {
      var trigger = item.querySelector('.snav__top-link');
      var panel = item.querySelector('.snav__panel');
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      var done = () => { if (this.active !== item) panel.hidden = true; panel.removeEventListener('transitionend', done); };
      panel.addEventListener('transitionend', done);
      // Fallback must match the CSS transition-duration on .snav__panel
      setTimeout(done, 260);
    }
  }
  customElements.define('secundo-nav', SecundoNav);

  /* ---------- MOBILE ---------- */
  class SecundoMobileNav extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.smnav__toggle');
      this.drawer = this.querySelector('.smnav__drawer');
      this.overlay = this.querySelector('.smnav__overlay');
      this.levels = Array.from(this.querySelectorAll('.smnav__level'));
      this.stack = [];

      this.toggle && this.toggle.addEventListener('click', () => this.isOpen() ? this.closeDrawer() : this.openDrawer());
      this.overlay && this.overlay.addEventListener('click', () => this.closeDrawer());
      this.querySelectorAll('.smnav__close').forEach((b) => b.addEventListener('click', () => this.closeDrawer()));
      this.querySelectorAll('.smnav__drill').forEach((b) => b.addEventListener('click', () => this.drillTo(b.dataset.target)));
      this.querySelectorAll('.smnav__back').forEach((b) => b.addEventListener('click', () => this.back()));
      this._onDocKeydown = (e) => { if (e.key === 'Escape' && this.isOpen()) this.closeDrawer(); };
      document.addEventListener('keydown', this._onDocKeydown);
      this.querySelectorAll('a[href]').forEach((a) => a.addEventListener('pointerenter', () => prefetch(a.getAttribute('href'))));
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this._onDocKeydown);
    }
    isOpen() { return this.drawer && this.drawer.classList.contains('is-open'); }
    openDrawer() {
      this.overlay.hidden = false; this.drawer.hidden = false;
      requestAnimationFrame(() => { this.overlay.classList.add('is-open'); this.drawer.classList.add('is-open'); });
      this.toggle.setAttribute('aria-expanded', 'true'); document.body.classList.add('smnav-open');
    }
    closeDrawer() {
      this.overlay.classList.remove('is-open'); this.drawer.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false'); document.body.classList.remove('smnav-open');
      // Fallback must match the CSS transition-duration on .smnav__drawer/.smnav__level
      setTimeout(() => { if (!this.isOpen()) { this.overlay.hidden = true; this.drawer.hidden = true; } }, 280);
      this.resetLevels();
    }
    levelEl(name) { return this.levels.find((l) => l.dataset.level === name); }
    drillTo(name) {
      var next = this.levelEl(name); if (!next) return;
      var current = this.stack.length ? this.levelEl(this.stack[this.stack.length - 1]) : this.levelEl('root');
      current && current.classList.add('is-parked');
      next.hidden = false;
      requestAnimationFrame(() => next.classList.add('is-active'));
      this.stack.push(name);
    }
    back() {
      var name = this.stack.pop(); var current = this.levelEl(name);
      current && current.classList.remove('is-active');
      var prev = this.stack.length ? this.levelEl(this.stack[this.stack.length - 1]) : this.levelEl('root');
      prev && prev.classList.remove('is-parked');
      // Fallback must match the CSS transition-duration on .smnav__drawer/.smnav__level
      setTimeout(() => { if (current && !current.classList.contains('is-active')) current.hidden = true; }, 280);
    }
    resetLevels() {
      this.stack = [];
      this.levels.forEach((l) => { if (l.dataset.level !== 'root') { l.classList.remove('is-active'); l.hidden = true; } l.classList.remove('is-parked'); });
    }
  }
  customElements.define('secundo-mobile-nav', SecundoMobileNav);
})();
